import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  userUID!: string;
  userRoles: any;
  bmi: string | undefined;
  roleId!: string;
  medHistory!: string;
  dataSubject = new BehaviorSubject<any>(null);
  constructor() {}

  setUserUID(userUID: string) {
    this.userUID = userUID;
  }

  setUserRoles(userRoles: any) {
    this.userRoles = userRoles;
  }

  setBMI(bmi: string | undefined) {
    this.bmi = bmi;
  }

  setRoleId(roleId: string) {
    this.roleId = roleId;
  }

  setMedHistory(medHistory: string) {
    this.medHistory = medHistory;
  }

  getData(): Observable<any> {
    return this.dataSubject.asObservable();
  }
}
